package com.wintermar.inspection.feature.presentation.inspection.landing.widget

import androidx.compose.runtime.Composable
import com.wintermar.inspection.core.ui.component.modal.ModalDialog

@Composable
actual fun InspectionLandingMoreActionModal(
    show: Boolean,
    onDismiss: () -> Unit,
    content: @Composable (() -> Unit)
) {
    ModalDialog(
        show = show,
        onDismiss = onDismiss,
        content = {
            content()
        }
    )
}
